import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$1kqany0t1jivl as LinkedHashMap_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  IllegalArgumentException_init_$Create$1jufhs63t8y6o as IllegalArgumentException_init_$Create$,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  enumEntries20mr21zbe3az4 as enumEntries,
  Enum3alwj03lh1n41 as Enum,
  toString1pkumu07cwy4m as toString,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  defineProp3hxgpk2knu2px as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AirtaskerRegion, 'AirtaskerRegion', VOID, Enum);
//endregion
var AirtaskerRegion_AUSTRALIA_instance;
var AirtaskerRegion_IRELAND_instance;
var AirtaskerRegion_NEW_ZEALAND_instance;
var AirtaskerRegion_SINGAPORE_instance;
var AirtaskerRegion_UNITED_KINGDOM_instance;
var AirtaskerRegion_UNITED_STATES_instance;
function Companion() {
  Companion_instance = this;
  var tmp = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get_entries();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var tmp0_iterator = this_0.d();
  while (tmp0_iterator.e()) {
    var element = tmp0_iterator.f();
    // Inline function 'com.airtasker.kmp.fundamental.Companion.byAirtaskerRegionCode.<anonymous>' call
    var tmp$ret$0 = element.airtaskerRegionCode;
    destination.p1(tmp$ret$0, element);
  }
  tmp.f4_1 = destination;
  var tmp_0 = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = get_entries();
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var tmp0_iterator_0 = this_1.d();
  while (tmp0_iterator_0.e()) {
    var element_0 = tmp0_iterator_0.f();
    // Inline function 'com.airtasker.kmp.fundamental.Companion.byIsoAlpha2CountryCode.<anonymous>' call
    var tmp$ret$3 = element_0.isoAlpha2CountryCode;
    destination_0.p1(tmp$ret$3, element_0);
  }
  tmp_0.g4_1 = destination_0;
  var tmp_1 = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_2 = get_entries();
  var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_1 = LinkedHashMap_init_$Create$(capacity_1);
  var tmp0_iterator_1 = this_2.d();
  while (tmp0_iterator_1.e()) {
    var element_1 = tmp0_iterator_1.f();
    // Inline function 'com.airtasker.kmp.fundamental.Companion.byIsoAlpha3CountryCode.<anonymous>' call
    var tmp$ret$6 = element_1.isoAlpha3CountryCode;
    destination_1.p1(tmp$ret$6, element_1);
  }
  tmp_1.h4_1 = destination_1;
}
protoOf(Companion).fromAirtaskerRegionCode = function (airtaskerRegionCode) {
  var tmp0_elvis_lhs = this.f4_1.n(airtaskerRegionCode);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("Invalid Airtasker region code '" + airtaskerRegionCode + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion).fromIsoAlpha2CountryCode = function (isoAlpha2CountryCode) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = isoAlpha2CountryCode.toUpperCase();
  var tmp0_elvis_lhs = this.g4_1.n(tmp$ret$1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("Invalid ISO 3166-1 alpha-2 country code '" + isoAlpha2CountryCode + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion).fromIsoAlpha3CountryCode = function (isoAlpha3CountryCode) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = isoAlpha3CountryCode.toUpperCase();
  var tmp0_elvis_lhs = this.h4_1.n(tmp$ret$1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("Invalid ISO 3166-1 alpha-3 country code '" + isoAlpha3CountryCode + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var Companion_instance;
function Companion_getInstance() {
  AirtaskerRegion_initEntries();
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function values() {
  return [AirtaskerRegion_AUSTRALIA_getInstance(), AirtaskerRegion_IRELAND_getInstance(), AirtaskerRegion_NEW_ZEALAND_getInstance(), AirtaskerRegion_SINGAPORE_getInstance(), AirtaskerRegion_UNITED_KINGDOM_getInstance(), AirtaskerRegion_UNITED_STATES_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'AUSTRALIA':
      return AirtaskerRegion_AUSTRALIA_getInstance();
    case 'IRELAND':
      return AirtaskerRegion_IRELAND_getInstance();
    case 'NEW_ZEALAND':
      return AirtaskerRegion_NEW_ZEALAND_getInstance();
    case 'SINGAPORE':
      return AirtaskerRegion_SINGAPORE_getInstance();
    case 'UNITED_KINGDOM':
      return AirtaskerRegion_UNITED_KINGDOM_getInstance();
    case 'UNITED_STATES':
      return AirtaskerRegion_UNITED_STATES_getInstance();
    default:
      AirtaskerRegion_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var AirtaskerRegion_entriesInitialized;
function AirtaskerRegion_initEntries() {
  if (AirtaskerRegion_entriesInitialized)
    return Unit_instance;
  AirtaskerRegion_entriesInitialized = true;
  AirtaskerRegion_AUSTRALIA_instance = new AirtaskerRegion('AUSTRALIA', 0, '1036', 'AU', 'AUS', 'en-AU', 'au');
  AirtaskerRegion_IRELAND_instance = new AirtaskerRegion('IRELAND', 1, '1372', 'IE', 'IRL', 'en-IE', 'ie');
  AirtaskerRegion_NEW_ZEALAND_instance = new AirtaskerRegion('NEW_ZEALAND', 2, '1554', 'NZ', 'NZL', 'en-NZ', 'nz');
  AirtaskerRegion_SINGAPORE_instance = new AirtaskerRegion('SINGAPORE', 3, '1702', 'SG', 'SGP', 'en-SG', 'sg');
  AirtaskerRegion_UNITED_KINGDOM_instance = new AirtaskerRegion('UNITED_KINGDOM', 4, '1826', 'GB', 'GBR', 'en-GB', 'uk');
  AirtaskerRegion_UNITED_STATES_instance = new AirtaskerRegion('UNITED_STATES', 5, '1840', 'US', 'USA', 'en-US', 'us');
  Companion_getInstance();
}
var $ENTRIES;
function AirtaskerRegion(name, ordinal, airtaskerRegionCode, isoAlpha2CountryCode, isoAlpha3CountryCode, defaultLocaleName, websiteCountryNamespace) {
  Enum.call(this, name, ordinal);
  this.airtaskerRegionCode = airtaskerRegionCode;
  this.isoAlpha2CountryCode = isoAlpha2CountryCode;
  this.isoAlpha3CountryCode = isoAlpha3CountryCode;
  this.defaultLocaleName = defaultLocaleName;
  this.websiteCountryNamespace = websiteCountryNamespace;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.airtaskerRegionCode.length === 4)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message = 'Airtasker region code must be 4 characters long';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!(toIntOrNull(this.airtaskerRegionCode) == null)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_0 = 'Airtasker region code must be a 4-digit integer';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.isoAlpha2CountryCode.length === 2)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_1 = 'ISO alpha-2 country code must be 2 characters long';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = this.isoAlpha2CountryCode.toUpperCase();
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.isoAlpha2CountryCode === tmp$ret$4)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_2 = 'ISO alpha-2 country code must be uppercase';
    throw IllegalArgumentException_init_$Create$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.isoAlpha3CountryCode.length === 3)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_3 = 'ISO alpha-3 country code must be 3 characters long';
    throw IllegalArgumentException_init_$Create$(toString(message_3));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = this.isoAlpha3CountryCode.toUpperCase();
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.isoAlpha3CountryCode === tmp$ret$8)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_4 = 'ISO alpha-3 country code must be uppercase';
    throw IllegalArgumentException_init_$Create$(toString(message_4));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = this.defaultLocaleName;
  // Inline function 'kotlin.contracts.contract' call
  if (!(charSequenceLength(this_0) > 0)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_5 = 'The default locale name must be supplied';
    throw IllegalArgumentException_init_$Create$(toString(message_5));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.websiteCountryNamespace.length === 2)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_6 = 'Website country namespace must be 2 characters long';
    throw IllegalArgumentException_init_$Create$(toString(message_6));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = this.websiteCountryNamespace.toLowerCase();
  // Inline function 'kotlin.contracts.contract' call
  if (!(this.websiteCountryNamespace === tmp$ret$14)) {
    // Inline function 'com.airtasker.kmp.fundamental.AirtaskerRegion.<anonymous>' call
    var message_7 = 'Website country namespace must be lowercase';
    throw IllegalArgumentException_init_$Create$(toString(message_7));
  }
}
protoOf(AirtaskerRegion).i4 = function () {
  return this.airtaskerRegionCode;
};
protoOf(AirtaskerRegion).j4 = function () {
  return this.isoAlpha2CountryCode;
};
protoOf(AirtaskerRegion).k4 = function () {
  return this.isoAlpha3CountryCode;
};
protoOf(AirtaskerRegion).l4 = function () {
  return this.defaultLocaleName;
};
protoOf(AirtaskerRegion).m4 = function () {
  return this.websiteCountryNamespace;
};
function AirtaskerRegion_AUSTRALIA_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_AUSTRALIA_instance;
}
function AirtaskerRegion_IRELAND_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_IRELAND_instance;
}
function AirtaskerRegion_NEW_ZEALAND_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_NEW_ZEALAND_instance;
}
function AirtaskerRegion_SINGAPORE_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_SINGAPORE_instance;
}
function AirtaskerRegion_UNITED_KINGDOM_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_UNITED_KINGDOM_instance;
}
function AirtaskerRegion_UNITED_STATES_getInstance() {
  AirtaskerRegion_initEntries();
  return AirtaskerRegion_UNITED_STATES_instance;
}
//region block: post-declaration
defineProp(protoOf(AirtaskerRegion), 'name', protoOf(AirtaskerRegion).r);
defineProp(protoOf(AirtaskerRegion), 'ordinal', protoOf(AirtaskerRegion).s);
//endregion
//region block: exports
AirtaskerRegion.values = values;
AirtaskerRegion.valueOf = valueOf;
defineProp(AirtaskerRegion, 'AUSTRALIA', AirtaskerRegion_AUSTRALIA_getInstance);
defineProp(AirtaskerRegion, 'IRELAND', AirtaskerRegion_IRELAND_getInstance);
defineProp(AirtaskerRegion, 'NEW_ZEALAND', AirtaskerRegion_NEW_ZEALAND_getInstance);
defineProp(AirtaskerRegion, 'SINGAPORE', AirtaskerRegion_SINGAPORE_getInstance);
defineProp(AirtaskerRegion, 'UNITED_KINGDOM', AirtaskerRegion_UNITED_KINGDOM_getInstance);
defineProp(AirtaskerRegion, 'UNITED_STATES', AirtaskerRegion_UNITED_STATES_getInstance);
defineProp(AirtaskerRegion, 'Companion', Companion_getInstance);
export {
  AirtaskerRegion as AirtaskerRegion,
};
//endregion

//# sourceMappingURL=airtasker-kmp-fundamental-js.mjs.map
